function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.57755 4.88642C2.57755 4.83329 2.5814 4.78114 2.58883 4.73026L2.46591 4.72302C1.82631 4.6869 1.29297 5.17407 1.29297 5.78901V17.5201C1.29297 18.084 1.74888 18.5542 2.33535 18.5847C2.33535 18.5847 5.47485 18.9056 6.66767 19.2363C7.8605 19.567 11.4502 21.2879 12 21.2879C12.5498 21.2879 16.1291 19.6042 17.3323 19.2363C18.5356 18.8684 21.6647 18.5847 21.6647 18.5847C22.2511 18.5542 22.707 18.084 22.707 17.5201V5.78901C22.707 5.17407 22.1737 4.6869 21.5341 4.72302L21.4112 4.73026C21.4186 4.78114 21.4224 4.83329 21.4224 4.88642V16.1995C21.4224 16.7433 21.0121 17.1967 20.4843 17.2262C18.9417 17.313 15.4258 17.918 13.2624 19.0788L12 19.7476L10.7376 19.0788C8.57422 17.918 5.05829 17.313 3.51569 17.2262C2.98787 17.1967 2.57755 16.7433 2.57755 16.1995V4.88642Z",
  fill: "#1A1D1F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2897 4.32465C9.34145 3.13189 6.18509 2.80415 4.59706 2.71373C4.06328 2.68359 3.61816 3.09016 3.61816 3.60338V15.3938C3.61816 15.8644 3.99865 16.2568 4.4881 16.2823C5.92226 16.3576 8.82302 16.6332 10.8278 17.6428C11.1355 17.7979 11.5004 17.5866 11.5004 17.2528V4.70109C11.5004 4.54779 11.4244 4.40724 11.2897 4.32465Z",
  fill: "#1A1D1F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7103 4.32465C14.6586 3.13189 17.8149 2.80415 19.4029 2.71373C19.9367 2.68359 20.3818 3.09016 20.3818 3.60338V15.3938C20.3818 15.8644 20.0013 16.2568 19.5119 16.2823C18.0777 16.3576 15.177 16.6332 13.1722 17.6428C12.8645 17.7979 12.4996 17.5866 12.4996 17.2528V4.70109C12.4996 4.54779 12.5756 4.40724 12.7103 4.32465Z",
  fill: "#1A1D1F"
});

function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/Blog.e144046ee94134e4bb4ae0f3e87d036b.svg";
export { ForwardRef as ReactComponent };